









import { Result } from '@empathy/search-types';
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { EVENTS } from '../../../bus/events.const';
import { TrackClickEvents } from '../../../models';
import { TrackClickMixin } from '../../mixins/trackable-click.mixin';

const DefaultResultTrackingClickEvents: TrackClickEvents = {
  click: EVENTS.ResultClicked,
  rightClick: EVENTS.ResultRightClicked
};

@Component
export default class ResultLink extends Mixins(TrackClickMixin) {
  // Object & Arrays prop defaults must be returned from a function https://vuejs.org/v2/guide/components-props.html
  @Prop({ default: () => DefaultResultTrackingClickEvents })
  clickEvents: TrackClickEvents;

  @Prop({ required: true })
  item: Result;
}
